//#region imports
import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/services/notification.service';
import { Globals } from 'src/app/services/globals';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { Pricing, TarifCheckboxStatus } from '../../model/guarantee.model';
import { DecimalPipe } from '@angular/common';
import { SectionService } from 'src/app/services/section.service';
//#endregion

@Component({
  selector: 'app-guarantee-question3',
  templateUrl: './guarantee-question3.component.html',
  styleUrls: ['./guarantee-question3.component.css']
})
export class GuaranteeQuestion3Component implements OnInit, AfterViewChecked {
  //#region variables
  premiumTotalAmount: number;
  premiumTotalAmountStr: string;
  premiumAmountVATLegalProtection: number;
  premiumAmountVATLegalProtectionStr: string;
  legalProtectionChecked: boolean;
  tarifCheckboxStatus: TarifCheckboxStatus;
  initialPricingData: Pricing;
  updatedPricingData: Pricing;
  //#endregion

  //#region methods
  constructor(
    private guaranteeService: GuaranteeService, private notification: NotificationService,
    private translate: TranslateService, private globals: Globals, private decimalPipe: DecimalPipe,
    private sectionService: SectionService) {
    this.guaranteeService.setshowNormalTitle(false);
  }

  ngOnInit() {
    this.sectionService.setCurrentPage('P3-3');
    this.globals.trackPageActivity += ';' + 'P3-3';
    this.initialPricingData = this.guaranteeService.getInitialPricingData();
    this.updatedPricingData = this.guaranteeService.getUpdatedPricingData();
    this.tarifCheckboxStatus = this.guaranteeService.getTarifCheckboxStatus();
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.legalProtectionChecked = this.updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked;
      this.premiumTotalAmountStr = this.updatedPricingData.Tarification.Premium_Total_Amount;
      this.premiumTotalAmount = this.convertStringToNumber(this.premiumTotalAmountStr);
      this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      this.premiumAmountVATLegalProtectionStr = this.updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection;
      this.premiumAmountVATLegalProtection = +this.premiumAmountVATLegalProtectionStr.replace(',', '.');
    } else {
      this.legalProtectionChecked = this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked;
      this.premiumTotalAmountStr = this.initialPricingData.Tarification.Premium_Total_Amount;
      this.premiumTotalAmount = this.convertStringToNumber(this.premiumTotalAmountStr);
      this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      this.premiumAmountVATLegalProtectionStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection;
      this.premiumAmountVATLegalProtection = +this.premiumAmountVATLegalProtectionStr.replace(',', '.');
    }
    this.guaranteeService.setEnsuringContentCalcFirstTime(false);
  }

  ngAfterViewChecked() {
    this.globals.guaranteeHeader2 = true;
  }

  onChange($event) {
    this.guaranteeService.setGuaranteeProgressBarDetails();
    if(this.globals.isMobile)
    {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
    if ($event.target.checked) {
      this.checkedLegalProtection();
      this.legalProtectionChecked = true;
    } else {
      this.unCheckedLegalProtection();
      this.legalProtectionChecked = false;
    }
  }

  checkedLegalProtection() {
    this.premiumTotalAmount = this.premiumTotalAmount + this.premiumAmountVATLegalProtection;
    this.premiumTotalAmountStr = this.convertNumberToString(this.premiumTotalAmount);
    this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
      this.updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked = true;
      this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
    } else {
      this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked = true;
      this.guaranteeService.setInitialPricingData(this.initialPricingData);
    }
    this.tarifCheckboxStatus.Premium_Amount_VAT_Legal_Protection_Checked = true;
    this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
  }

  unCheckedLegalProtection() {
    this.premiumTotalAmount = this.premiumTotalAmount - this.premiumAmountVATLegalProtection;
    this.premiumTotalAmountStr = this.convertNumberToString(this.premiumTotalAmount);
    this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
      this.updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked = false;
      this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
    } else {
      this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked = false;
      this.guaranteeService.setInitialPricingData(this.initialPricingData);
    }
    this.tarifCheckboxStatus.Premium_Amount_VAT_Legal_Protection_Checked = false;
    this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
  }

  convertStringToNumber(value: string): number {
    return +(value.replace(',', '.'));
  }

  convertNumberToString(value: number): string {
    return this.decimalPipe.transform(value, '0.2-2').replace(',', '').replace('.', ',');
  }

  helpDialog(value: string) {
    value = this.translate.instant(value);
    this.notification.openDialog(value);
  }
  //#endregion
}
